import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IBackupState} from "../reducers/backup.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBackupState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.backup);

export const getWebsiteBackup = (websiteId: number) => createSelector(getBackupState,
  (state: IBackupState) =>
    state.entities[websiteId] && state.entities[websiteId].entities ? Object.values(state.entities[websiteId].entities) : []
);

export const getWebsiteBackupMap = (websiteId: number) => createSelector(getBackupState,
  (state: IBackupState) =>
    state.entities[websiteId] ? state.entities[websiteId].entities : []
);

export const getWebsiteBackupLoading = (websiteId: number) => createSelector(getBackupState,
  (state: IBackupState) =>
    state.entities[websiteId] ? state.entities[websiteId].loading : false
);

export const getWebsiteBackupLoaded = (websiteId: number) => createSelector(getBackupState,
  (state: IBackupState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
